// extracted by mini-css-extract-plugin
export default {"container":"tO-z","darkBackground":"uO-z","whiteBackground":"vO-z","headerButton":"wO-z","calloutHeading":"xO-z","calloutSubHeading":"yO-z"};